import { useEffect } from "react";
import useBreadcrumbs from "../../hooks/useBreadcrumbs";
import { useTenantBranding } from "../../utils/tenantBranding";

// Keeps the browser tab title in step with the breadcrumb trail, most
// specific crumb first so it survives a narrow tab, e.g.
// "Edit · BlackFriday 2025 · Campaigns | Intelligence". Pages without a trail
// (login, unknown paths) fall back to the plain tenant title.
const DocumentTitle: React.FC = () => {
  const crumbs = useBreadcrumbs();
  const { title: brand } = useTenantBranding();

  const trail = crumbs
    .map((crumb) => crumb.label)
    .reverse()
    .join(" · ");

  useEffect(() => {
    document.title = trail && brand ? `${trail} | ${brand}` : trail || brand;
  }, [trail, brand]);

  return null;
};

export default DocumentTitle;
